export default __webpack_public_path__ + "static/media/color-circle.4e9a73af.svg";